"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollapsingNavWrapStyled = exports.ButtonStyled = exports.LinksGridItemStyled = exports.LinksGridStyled = exports.StyledBox = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _list = require("@dbi-tools/ui-kit/lib/components/list");

var _const = require("@dbi-tools/ui-kit/lib/const");

var _collapsingNav = require("@dbi-tools/ui-kit/lib/ecommerce/components/collapsing-nav");

var _helpers = require("../../helpers");

var _useMedia = require("../../hooks/use-media");

var _const2 = require("../video/const");

var _const3 = require("./const");

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      ", " {\n        ", "\n\n        ", " {\n          ", ";\n          color: ", ";\n\n          padding: 20px !important;\n\n          ", " {\n            ", "\n          }\n        }\n\n        ", " {\n          position: inherit;\n\n          ", ";\n          border-top: none;\n\n          ", " {\n            border-top: none;\n\n            ", " {\n              padding: 0;\n\n              ", " {\n                margin: 0;\n                line-height: 12px;\n\n                ", " {\n                  ", ";\n                  color: ", ";\n                  display: block;\n                  padding: 20px;\n                }\n              }\n            }\n          }\n        }\n      }\n\n      ", " {\n        svg * {\n          fill: ", ";\n        }\n      }\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 30px;\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  line-height: 12px;\n  letter-spacing: 1.65px;\n  font-weight: bold;\n  text-transform: uppercase;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 45px 0 0;\n  display: grid;\n  flex-wrap: wrap;\n  gap: ", "px;\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    grid-template-columns: repeat(auto-fill, calc((100% - ", "px) / ", "));\n\n    ", " {\n      grid-template-columns: none;\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledBox = (0, _uiKit.styled)(_uiKit.Box)(_templateObject(), function (_ref) {
  var $theme = _ref.theme.$theme;
  return $theme && (0, _helpers.getTheme)($theme);
});
exports.StyledBox = StyledBox;

var getColumns = function getColumns(columns) {
  var isTablet = (0, _useMedia.useMedia)(_const2.Breakpoints.TABLET); // if is tablet & four columns we take away two column

  var columnsDevice = isTablet ? columns === 4 ? columns - 2 : columns : columns;
  var gapNormalize = _const3.DEFAULT_GAP * columnsDevice - _const3.DEFAULT_GAP;
  return (0, _uiKit.css)(_templateObject2(), gapNormalize, columnsDevice, _const.GridBreakpointsMediaDown.md);
};

var LinksGridStyled = (0, _uiKit.styled)(_list.ListStyled)(_templateObject3(), _const3.DEFAULT_GAP, function (_ref2) {
  var columns = _ref2.columns;
  return getColumns(columns);
});
exports.LinksGridStyled = LinksGridStyled;
var LinksGridItemStyled = (0, _uiKit.styled)(_list.ListItemStyled)(_templateObject4());
exports.LinksGridItemStyled = LinksGridItemStyled;
var ButtonStyled = (0, _uiKit.styled)(_uiKit.Button)(_templateObject5(), _uiKit.Colors.white);
exports.ButtonStyled = ButtonStyled;

var getBlockStyle = function getBlockStyle(navColor, navStyle) {
  return navStyle === 'outlined' ? (0, _uiKit.css)(_templateObject6(), _uiKit.Colors.transparent) : "background-color: ".concat(_uiKit.Colors[navColor]);
};

var btnTitleStyle = (0, _uiKit.css)(_templateObject7(), _uiKit.TextSize.xxs);
var CollapsingNavWrapStyled = (0, _uiKit.styled)('div')(_templateObject8(), function (_ref3) {
  var navColor = _ref3.navColor,
      navStyle = _ref3.navStyle,
      accentColor = _ref3.accentColor;
  return navColor && navStyle && (0, _uiKit.css)(_templateObject9(), _collapsingNav.CollapsingNavStyled, navStyle === 'outlined' && "border: 1px solid ".concat(_uiKit.Colors[accentColor], ";"), _collapsingNav.CollapsingNavTargetStyled, getBlockStyle(navColor, navStyle), _uiKit.Colors[accentColor], _collapsingNav.CollapsingNavHeadingStyled, btnTitleStyle, _collapsingNav.CollapsingNavBodyStyled, getBlockStyle(navColor, navStyle), _collapsingNav.CollapsingNavLinksBlockStyled, _collapsingNav.CollapsingNavLinksListStyled, _collapsingNav.CollapsingNavLinksListItemStyled, _collapsingNav.CollapsingNavAStyled, btnTitleStyle, _uiKit.Colors[accentColor], _collapsingNav.CollapsingNavIconsWrapperStyled, _uiKit.Colors[accentColor]);
});
exports.CollapsingNavWrapStyled = CollapsingNavWrapStyled;